var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentElementProps.length)?_c('div',[_c('div',{staticClass:"attr-title marginB10 fontBold"},[_vm._v("组件属性")]),_c('el-form',_vm._l((_vm.currentElementProps),function(item){return _c('attr-' + item,_vm._b({key:item,tag:"component"},'component',_vm.activeElement.propsValue,false,true))}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }